<template>
    <div>
        <div class="block md:hidden">
            <div class="background--paper divider--container h-5">
                <div class="divider-white--top"></div>
                <div class="divider-white--bottom"></div>
            </div>
            <gift-type-boxes
                @select-subscription="selectSubscription"
                @select-one-box="selectOneBox"/>
        </div>

        <div class="background--paper divider--container py-2 hidden md:block">
            <div class="divider-white--top"></div>
            <gift-type-boxes
                @select-subscription="selectSubscription"
                @select-one-box="selectOneBox"/>
            <div class="divider-white--bottom"></div>
        </div>
    </div>
</template>

<script>
import GiftTypeBoxes from '@/components/partials/account/gifting/GiftTypeBoxes';
import { SECTION_CHOOSE_A_GIFT, GIFT_TYPE_ONE_OFF, GIFT_TYPE_SUBSCRIPTION } from '@/constants/Gifting';

export default {
    name: 'ChooseGiftType',
    components: {
        GiftTypeBoxes,
    },
    methods: {
        /**
         * Handle selecting a one box gift.
         *
         * @returns {void}
         */
        selectOneBox() {
            this.$store.commit('gifting/resetState');
            setTimeout(() => {
                this.$store.dispatch('gifting/fetchPrices');
                this.$store.commit('gifting/setDeliveryType', GIFT_TYPE_ONE_OFF);
                this.$store.commit('gifting/setSectionComplete', SECTION_CHOOSE_A_GIFT);
                this.$router.push({ name: 'account.gifting.delivery-address' });
            }, 1);
        },

        /**
         * Handle selecting a subscription gift.
         *
         * @returns {void}
         */
        selectSubscription() {
            this.$store.commit('gifting/resetState');
            setTimeout(() => {
                this.$store.dispatch('gifting/fetchPrices');
                this.$store.commit('gifting/setDeliveryType', GIFT_TYPE_SUBSCRIPTION);
                this.$store.commit('gifting/setSectionComplete', SECTION_CHOOSE_A_GIFT);
                this.$router.push({ name: 'account.gifting.number-of-deliveries' });
            }, 1);
        },
    },
    mounted() {
        this.$store.dispatch('gifting/fetchPrices');
    },
};
</script>
